import React, { Component } from "react";
import { Alert, Toast, Button, Modal } from "react-bootstrap";

class PopUp extends React.Component {
  /*   render() {
    return (
      <div className="popup">
        <div className="popup_inner">
          <h1>{this.props.text}</h1>
          <button onClick={this.props.closePopup}>close me</button>
        </div>
      </div>
    );
  }
}
{
  this.state.showPopup ? (
    <Popup text="Close Me" closePopup={this.togglePopup.bind(this)} />
  ) : null; */
}
export default PopUp;
